import { Link } from 'react-router-dom';

export default function DatenschutzPage() {
  return (
    <div className="min-h-screen bg-paper">
      <div className="mx-auto max-w-3xl px-5 py-8 sm:py-12">
        <Link to="/" className="label-mono inline-flex h-11 items-center rounded-btn border-2 border-ink bg-cream px-3.5 !text-ink">
          ← Zurück zu VOC7
        </Link>

        <h1 className="mt-6 text-4xl font-extrabold tracking-tight sm:text-5xl">
          Datenschutzerklärung
        </h1>
        <p className="label-mono mt-3">Stand: Juli 2026</p>

        <div className="mt-8 space-y-5 leading-relaxed text-body">
          <section className="rounded-panel border-2.5 border-ink bg-cream p-5 shadow-hard">
            <h2 className="mb-2 text-xl font-bold text-ink">1. Verantwortliche</h2>
            <p>
              Verantwortlich für die Datenverarbeitung in der VOC7-App und auf dieser Website sind
              Julian und Noel (VOC7). Du erreichst uns unter{' '}
              <a href="mailto:support@n-mayr.net" className="font-bold text-ink underline decoration-marker decoration-2 underline-offset-4">
                support@n-mayr.net
              </a>.
            </p>
          </section>

          <section className="rounded-panel border-2.5 border-ink bg-cream p-5 shadow-hard">
            <h2 className="mb-2 text-xl font-bold text-ink">2. Welche Daten wir verarbeiten</h2>
            <ul className="list-disc pl-6 space-y-1">
              <li>
                <strong>Kontodaten:</strong> Nickname, Anzeigename und dein Passwort (ausschließlich
                als sicherer Hash gespeichert, niemals im Klartext).
              </li>
              <li>
                <strong>Lerndaten:</strong> Deine Kurse, Vokabeln, Quiz-Antworten und der
                Lernfortschritt pro Vokabel (Phase, zuletzt geübt).
              </li>
              <li>
                <strong>Technische Daten:</strong> Sitzungs-Tokens für den Login (als Cookie bzw. im
                sicheren Gerätespeicher der App).
              </li>
            </ul>
            <p className="mt-2">
              Eine E-Mail-Adresse ist für die Nutzung nicht erforderlich. Wir erfassen keine
              Standortdaten, keine Werbe-IDs und erstellen keine Nutzungsprofile.
            </p>
          </section>

          <section className="rounded-panel border-2.5 border-ink bg-cream p-5 shadow-hard">
            <h2 className="mb-2 text-xl font-bold text-ink">3. Wofür wir die Daten nutzen</h2>
            <p>
              Ausschließlich für den Betrieb von VOC7: Login, Synchronisation deiner Kurse und deines
              Lernfortschritts zwischen App und Website sowie die Anzeige deiner Statistiken. In
              gemeinsamen Kursen sehen andere Mitglieder deinen Anzeigenamen und Nickname — dein
              Lernfortschritt bleibt privat.
            </p>
          </section>

          <section className="rounded-panel border-2.5 border-ink bg-cream p-5 shadow-hard">
            <h2 className="mb-2 text-xl font-bold text-ink">4. Kein Tracking, keine Werbung</h2>
            <p>
              VOC7 enthält keine Analyse- oder Werbedienste von Drittanbietern. Es werden keine Daten
              an Dritte verkauft oder weitergegeben. Cookies verwenden wir nur, soweit sie für den
              Login technisch notwendig sind.
            </p>
          </section>

          <section className="rounded-panel border-2.5 border-ink bg-cream p-5 shadow-hard">
            <h2 className="mb-2 text-xl font-bold text-ink">5. Speicherung und Löschung</h2>
            <p>
              Deine Daten liegen auf unseren eigenen Servern und werden so lange gespeichert, wie dein
              Konto besteht. Du kannst dein Konto jederzeit selbst löschen — in der App unter
              „Profil → Konto löschen" oder auf der Website im Profil. Damit werden dein Konto und
              deine persönlichen Lerndaten unwiderruflich entfernt.
            </p>
          </section>

          <section className="rounded-panel border-2.5 border-ink bg-cream p-5 shadow-hard">
            <h2 className="mb-2 text-xl font-bold text-ink">6. Deine Rechte</h2>
            <p>
              Du hast das Recht auf Auskunft, Berichtigung, Löschung und Einschränkung der
              Verarbeitung deiner personenbezogenen Daten sowie das Recht auf Datenübertragbarkeit
              und Beschwerde bei einer Aufsichtsbehörde. Schreib uns dafür einfach an{' '}
              <a href="mailto:support@n-mayr.net" className="font-bold text-ink underline decoration-marker decoration-2 underline-offset-4">
                support@n-mayr.net
              </a>.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}
